import * as Scrivito from "scrivito"
import { ScrivitoPageTitle } from "scrivito/components/ScrivitoPageTitle"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"
import { ScrivitoPageBreadcrumb } from "scrivito/scrivito-breadcrumb/ScrivitoPageBreadcrumb"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { KpiPageObj } from "./KpiPageObjClass"
import "./styles/_kpi-page.scss"

export interface KpiPageProps {
  page: KpiPageObj
}

export function KpiPage({ page }: KpiPageProps) {
  useScrollController()
  useScrivitoPage()

  return (
    <div className="kpi-page">
      <ScrivitoPageBreadcrumb page={page} />
      <div className="kpi-page__title" aria-live="polite">
        <ScrivitoPageTitle page={page} />
      </div>
      <Scrivito.ContentTag className="page" content={page} attribute="body" />
    </div>
  )
}
